import React from 'react';

import ImageBlock from './image-block';
import ParsedTextBlock from './parsed-text-block';
import { getHotelPageLink } from '../utils';

import { ContentBlocksProps } from './types';

import styles from './ContentBlocks.module.scss';

const ContentBlocks: React.FC<ContentBlocksProps> = ({ blocks }) => {
  return (
    <>
      {blocks.map((block, index) => (
        <div key={index} className={styles.container}>
          {block.image && (
            <ImageBlock
              block={block}
              hotelPageLink={getHotelPageLink(block.hotel_id, block.link)}
            />
          )}
          {block.text && <ParsedTextBlock block={block} />}
        </div>
      ))}
    </>
  );
};

export default ContentBlocks;
